export function progressState(totalWeight, thresholdGrams, boxUnitGrams) {
  const safeTotal = Math.max(0, Number(totalWeight) || 0);
  const safeThreshold = Math.max(1, Number(thresholdGrams) || 1);
  const safeBoxUnit = Math.max(1, Number(boxUnitGrams) || 1);
  const remaining = Math.max(0, safeThreshold - safeTotal);

  return {
    visible: safeTotal > 0,
    percent: Math.min(100, (safeTotal / safeThreshold) * 100),
    reached: safeTotal >= safeThreshold,
    remainingBoxes: Math.max(1, Math.ceil(remaining / safeBoxUnit)),
  };
}

const HTMLElementBase = typeof HTMLElement === "undefined" ? class {} : HTMLElement;

export class PbFreeShippingProgress extends HTMLElementBase {
  connectedCallback() {
    this.onCartChange = this.onCartChange?.bind(this) || this.handleCartChange.bind(this);
    document.addEventListener("cart:change", this.onCartChange);
    this.render(Number(this.dataset.totalWeight) || 0);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:change", this.onCartChange);
  }

  handleCartChange(event) {
    this.render(event.detail?.cart?.total_weight);
  }

  render(totalWeight) {
    const state = progressState(totalWeight, this.dataset.thresholdGrams, this.dataset.boxUnitGrams);
    this.hidden = !state.visible;
    this.dataset.totalWeight = String(Math.max(0, Number(totalWeight) || 0));
    if (!state.visible) return;

    const message = this.querySelector("[data-shipping-progress-message]");
    const track = this.querySelector("[data-shipping-progress-track]");
    const value = this.querySelector("[data-shipping-progress-value]");
    const text = state.reached
      ? this.dataset.reachedMessage
      : this.dataset.unreachedMessage.replace("{{ remaining_boxes }}", String(state.remainingBoxes));

    if (message) {
      message.textContent = text;
    }
    track?.setAttribute("aria-label", text);
    track?.setAttribute("aria-valuenow", String(Math.round(state.percent)));
    value?.style.setProperty("--pb-progress", `${state.percent}%`);
  }
}

if (typeof window !== "undefined" && !window.customElements.get("pb-free-shipping-progress")) {
  window.customElements.define("pb-free-shipping-progress", PbFreeShippingProgress);
}
